import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { UiComponentsModule } from './ui-components';
import { PipesModule } from 'pipes';
import { DropdownModule, ModalModule, FeatureModule } from './components';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DirectivesModule } from 'app/directives/directives.module';

const modules = [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatTooltipModule,
    ModalModule,
    UiComponentsModule,
    DropdownModule,
    PipesModule,
    DirectivesModule,
    FeatureModule
];

@NgModule({
    imports: [modules, TranslateModule.forChild()],
    exports: [TranslateModule, ...modules]
})
export class SharedModule {}
